import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { appSettings } from '@shared/components/appSettings';
import { ApiService } from '../../../services/api/api.service';

@Component({
  selector: 'app-mf-print-pdfs',
  templateUrl: './mf-print-pdfs.component.html',
  styleUrls: ['./mf-print-pdfs.component.css']
})
export class MfPrintPdfs implements OnInit {
  public selectedKeys: any;
  public loading: boolean;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private apiService: ApiService, public dialogRef: MatDialogRef<MfPrintPdfs>,
  ) {
    this.selectedKeys = this.data?.documents.map(o => { return o.id})
  }

  ngOnInit() {
  }

  public printDocs() {
    this.loading = true;
    this.apiService.post('/api/requisition/combinepdfs', { DigitalCabinetDocumentIds: this.selectedKeys })
      .subscribe(o => {
        const link = document.createElement('a');
        link.href = `${appSettings.apiServiceAddress}/api/fileServe/dynamic/${o.fileName}`;
        link.setAttribute('visibility', 'hidden');
        link.target = '_blank';
        link.click(); this.loading = false;
        this.dialogRef.close();
      }, err => {
        this.loading = false;
      });
  }
}
